<template>
    <div class="Folders">
        <div class="Folders__head">
            <button class="Folders__head-back" @click.prevent="$emit('close')">
                <i class="fas fa-chevron-left"></i>
            </button>
            <h3 class="Folders__head-title">Mes employés</h3>
        </div>
        <div class="Folders__scrollable">
            <div class="Folders__form">
                <h4 class="Folders__form-title">
                    <i class="fas fa-graduation-cap Folders__form-icon m-r-10"></i> Ajoutez vos formations
                </h4>
                <p class="Folders__form-text">
                    Ajoutez les formations validées de vos employés.
                </p>
                <div class="Form__group">
                    <multiselect
                        class="Select Select--small"
                        placeholder="Sélectionnez un employé"
                        open-direction="bottom"
                        :allow-empty="false"
                        :searchable="false"
                        :showLabels="false"
                        :options="folders"
                        v-model="selectedFolderToAdd"
                        label="name">
                        <span slot="noOptions">Aucun élément.</span>
                    </multiselect>
                </div>
                <div class="Form__group">
                    <multiselect
                        noOptions="Aucun élément."
                        class="Select Select--small"
                        placeholder="Sélectionnez une formation"
                        open-direction="bottom"
                        :allow-empty="false"
                        :searchable="false"
                        :showLabels="false"
                        :options="formations"
                        v-model="selectFormationToAdd"
                        label="name">
                        <span slot="noOptions">Aucun élément.</span>
                    </multiselect>
                </div>
                <button class="Btn Btn--stroked Btn--block Btn--small" @click.prevent="addFormations">Valider</button>
            </div>
            <div class="Folders__new">
                <div class="Folders__new-button" @click.prevent="openCreate">
                    <i class="fas fa-plus-circle Folders__new-icon"></i>
                    <span>Créer une fiche employé</span>
                </div>
                <ul class="Folders__new-instructions">
                    <li>Appuyez sur le bouton plus</li>
                    <li>Nommez votre employé</li>
                    <li>Sélectionnez les formations validées</li>
                    <li>Cliquez sur l’employé pour connaître les formations possibles</li>
                </ul>
            </div>
            <ul class="Folders__list">
                <li v-for="folder in folders" @click.prevent="open(folder)"
                    class="Folder"
                    :class="{'is-selected': selectedId === folder.id}"
                >
                    <div class="Folder__head">
                        <h4 class="Folder__head-name">{{ folder.name }}</h4>
                        <button class="Folder__remove" @click.stop="openDelete(folder)">
                            <i class="far fa-times-circle"></i>
                        </button>
                    </div>
                    <ul class="Folder__items">
                        <li class="Folder__item" v-if="folder.formations.length < 1">
                            <info-icon height="25" width="25" color="#ffed00"/>
                            <div class="Folder__item-data">
                                <h5 class="Folder__item-type">Vous n'avez ajouté aucune formation</h5>
                            </div>
                        </li>
                        <li class="Folder__item" v-for="formation in folder.formations">
                            <formation-icon height="25" width="25" color="#ffed00"/>
                            <div class="Folder__item-data">
                                <span class="Folder__item-name">{{ formation.name }}</span>
                            </div>
                            <button class="Folder__item-remove" @click.stop="openDeleteFormation(folder, formation)">
                                <i class="far fa-times-circle"></i>
                            </button>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import FormationIcon from "../icons/FormationIcon";
    import InfoIcon from "../icons/InfoIcon";
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import {actions, getters, mutations} from "../../store";
    import ModalBus from "../../eventBus";
    import CreateFolderModal from "../Modals/Folders/CreateFolderModal";
    import MemberAreaNav from "../MemberAreaNav";
    import Api from "../../services/Api";

    export default {
        components: {MemberAreaNav, FormationIcon, InfoIcon, Multiselect},
        data: function () {
            return {
                isContactsOpen: false,
                isAlertsOpen: false,
                isNavOpen: false,
                subOpenedId: null,
                selectedFolderToAdd: null,
                selectFormationToAdd: null
            }
        },
        computed: {
            folders: getters.folders,
            formations() {
                if (!this.selectedFolderToAdd) {
                    return getters.formationsList();
                }

                let formationIds = this.selectedFolderToAdd.formations.map(formation => formation.id);
                return getters.formationsList().filter(formation => !formationIds.includes(formation.id));
            },
            selectedId: function () {
                return this.$route.params.folderId;
            }
        },
        methods: {
            open(folder) {
                if (this.$route.params.folderId === folder.id) {
                    this.$emit('close');
                    return;
                }

                this.$router.push({name: 'folders_view', params: {folderId: folder.id}});
                this.$emit('close');
            },
            openCreate() {
                ModalBus.$emit('open', {component: CreateFolderModal});
            },
            openDelete(folder) {
                ModalBus.alert(
                    'Êtes-vous sûr ?',
                    `Voulez-vous vraiment supprimer l'employé &laquo; ${folder.name} &raquo; ?`,
                    {
                        icon: 'fas fa-question',
                        closeButton: false,
                        buttons: [
                            {
                                label: 'Non, annuler',
                                class: 'Btn Btn--stroked',
                                onClick: () => ModalBus.$emit('close')
                            },
                            {
                                label: 'Oui, supprimer',
                                class: 'Btn',
                                loading: true,
                                onClick: async () => {
                                    try {
                                        await Api.delete(`/folders/${folder.id}`);
                                        mutations.removeFolder(folder.id);

                                        if (this.$route.params.folderId === folder.id) {
                                            await this.$router.push({name: 'folders'});
                                        }

                                        ModalBus.$emit('close');
                                    } catch (err) {
                                        ModalBus.processingError();
                                    }
                                }
                            }
                        ]
                    }
                )
            },
            openDeleteFormation(folder, formation) {
                ModalBus.alert(
                    'Êtes-vous sûr ?',
                    `Voulez-vous vraiment supprimer la formation &laquo; ${formation.name} &raquo; de l'employé &laquo; ${folder.name} &raquo; ?`,
                    {
                        icon: 'fas fa-question',
                        closeButton: false,
                        buttons: [
                            {
                                label: 'Non, annuler',
                                class: 'Btn Btn--stroked',
                                onClick: () => ModalBus.$emit('close')
                            },
                            {
                                label: 'Oui, supprimer',
                                class: 'Btn',
                                onClick: async () => {
                                    try {
                                        await Api.delete(`/folders/${folder.id}/${formation.id}`);
                                        mutations.removeFormationFolder(folder.id, formation.id);

                                        if (this.$route.params.folderId === folder.id) {
                                            actions.fetchSuggestions(folder.id);
                                        }

                                        ModalBus.$emit('close');
                                    } catch (err) {
                                        ModalBus.processingError();
                                    }
                                }
                            }
                        ]
                    }
                )
            },
            async addFormations() {
                const {data} = await Api.post(`/folders/${this.selectedFolderToAdd.id}/addFormations`, {
                    formation_ids: [this.selectFormationToAdd.id]
                });
                mutations.pushFolders([data]);

                if (this.$route.params.folderId === this.selectedFolderToAdd.id) {
                    actions.fetchSuggestions(this.selectedFolderToAdd.id);
                }

                this.selectedFolderToAdd = null;
                this.selectFormationToAdd = null;
            }
        },
        created() {
            actions.fetchFolder();
            actions.fetchFormationsList();
        }
    }
</script>
